import Vue from 'vue'
import template from './_loading.pug'

// @vue/component
export default Vue.extend({
  template: template()
})
